module.exports = __webpack_public_path__ + "fbf7f082bb8abfeef11c89c77452f796.woff2";